module.exports = "<app-aside-nav></app-aside-nav>\r\n<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\r\n\t<router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/pages/default/default.component.html
// module id = ./src/app/theme/pages/default/default.component.html
// module chunks = main